// biome-ignore lint/style/noRestrictedImports: legacy import, will be migrated
import { Loader } from '@crehana/ui';

const LoadingOverlay = () => {
  return (
    <div className="absolute top-0 left-0 flex items-center justify-center w-full h-full z-dialog bg-base-main-80">
      <Loader size={48} white />
    </div>
  );
};

export default LoadingOverlay;
